import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../../generic-hooks'

import { DirectContactCallSchedulingDialogContent } from './DirectContactCallSchedulingDialogContent'

import styles from './DirectContactCallSchedulingDialog.module.css'

export const DirectContactCallSchedulingDialog: FC<{
  modalControls: OpenableControls
}> = ({ modalControls }) => {
  return (
    <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
      <DialogTitle onClose={modalControls.handleClose}>
        <FormattedMessage id="contact.callSchedulingModal.title" />
      </DialogTitle>
      <DialogContent
        className={clsx(
          'bg-light-primary-low pt-0 tablet:p-0',
          styles['call-scheduling-dialog-content'],
        )}
      >
        <DirectContactCallSchedulingDialogContent />
      </DialogContent>
    </Dialog>
  )
}
